// @flow

import type {ApplicationState} from '../../types'

import {createSelector} from 'reselect'

import {getCities} from './getCities'

export function getCityMap(appState: ApplicationState): Map<City> {
  return _getCityMap(appState.map) 
}

const _getCityMap = createSelector(
  [getCities.internal],
  (cities: City[]) => {
    return cities.reduce((result, c) => {
      return {
        ...result,
        [c._links.self]: c,
      }
    }, {})
  }
)


getCityMap.internal = _getCityMap
